import { render, staticRenderFns } from "./ProductAdmin.vue?vue&type=template&id=792736d4&"
import script from "./ProductAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports